import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import scope from "./scope";
import { useDispatch, useSelector } from "react-redux";
import { selectFetchingData, selectDefinitions } from "./selectors";
import React from "react";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.map((definition) => {
      const { issueCountType, summary } = definition;
      return {
        headerName: `Issue Count ${titleCase(issueCountType)}, ${titleCase(
          summary
        )}`,
        field: `${scope}, ${issueCountType}, ${summary}`,
        colId: `${scope}, ${issueCountType}, ${summary}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelData),
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
    });
  }, [definitions, dispatch, fetchingAbsData, fetchingRelData]);
};
